module.exports = __webpack_public_path__ + "static/hero-eggs-31317329dd264d059be7c040d28938be.png";